import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { Department} from '@signal/asp-data-commons';
import { MatDialog } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import * as fromScheduleDashboardSelector from '../../store/schedule-dashboard/schedule-dashboard.selectors';
import { Store } from '@ngrx/store';
import { IDashboardDetails, ScheduleDashboardState } from '../../store/schedule-dashboard/schedule-dashboard.reducer';
import { Observable } from 'rxjs';
import * as fromScheduleDashboardActions from '../../store/schedule-dashboard/schedule-dashboard.action';
import * as _ from 'lodash';
import { OverrideDialogComponent } from './override-dialog/override-dialog.component';
import { AuthService } from '../../shared/services/auth.service';
import { AspRoles, AspServiceAdminRoles, AspServiceAdminRolesT2, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { AlertService } from '../../shared/services/alert.service';
import { DashboardOverlay } from '../../shared/components/dashboard-overlay/dashboard-overlay.component';
import { DashboardOverlayService } from '../../shared/services/dashboardoverlay.service';
import { DashboardPrintOverlay } from '../../shared/components/dashboard-print-overlay/dashboard-print-overlay.component';
import { TeamState } from '../../store/team/team.reducer';
import * as fromTeamsActions from '../../store/team/team.actions';
import { selectTeams } from '../../store/team/team.selectors';
import { SubscriptionList } from '../../shared/models/asp.types';

@Component({
  selector: 'app-service-schedule-dashboard',
  templateUrl: './service-schedule-dashboard.component.html',
  styleUrls: ['./service-schedule-dashboard.component.scss']
})
export class ServiceScheduleDashboardComponent implements OnInit, OnDestroy {

  hoursOfOperation: string = '';
  department: Department = Department.SERVICE;
  dashboardDetails$ : Observable<IDashboardDetails>;
  dashboardDetails: IDashboardDetails;
  refreshTime: string = DateTime.now().toFormat('t');
  private userRoles: string[] = [];
  requiredRoles = [...AspServiceAdminRoles, ...AspServiceAdminRolesT2];
  requiredServiceRoles = [...AspRoles, ...AspServiceAdminRoles];
  isOverrideAllowed: boolean = true;
  isServiceRole: boolean = false;
  refreshInterval;
  appointmentDetails:any[];
  dateFormat : string = 'yyyy-MM-dd';
  private subs: SubscriptionList = {};


  constructor(private service: AuthService, public dialog: MatDialog, private cdref: ChangeDetectorRef, private scheduleDashboardState: Store<ScheduleDashboardState>,
    public dashboardOverlayService:DashboardOverlayService, private alertService : AlertService,
    private readonly teamsState: Store<TeamState>,
    ) {
      this.dashboardOverlayService.dispatchActions(this.department);
      this.subs.employeeRole = service.getEmployeeRoles().subscribe(t=>{
        this.userRoles = t;
        this.isServiceRole = _.every(this.requiredServiceRoles, (t) => this.userRoles.indexOf(t) >= 0);
        this.isOverrideAllowed = _.every(this.requiredRoles, (t) => this.userRoles.indexOf(t) >= 0);
      });
    this.dashboardOverlayService.getdatavalue(this.department);
    }

  ngOnInit(): void {
   this.setUpStore();
   this.refreshInterval = setInterval(()=>{
    this.autoRefresh();
   },300000)
  }

  setUpStore(){
    this.teamsState.dispatch(new fromTeamsActions.LoadTeams());
    this.teamsState.select(selectTeams);
    this.dashboardDetails$ = this.scheduleDashboardState.select(fromScheduleDashboardSelector.selectScheduleDashboardDetails);
    this.subs.dashboardDetails = this.dashboardDetails$.subscribe(details => {
      this.dashboardDetails = details;
    });
  }

  ngAfterContentChecked() {

    if (!this.cdref['destroyed']) {
      this.cdref.detectChanges();
    }

  }

  ngOnDestroy(){
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.ClearScheduleDashboardSlot({department: this.department}));
    clearInterval(this.refreshInterval);
    unsubscribeSubscriptions(this.subs);
    this.cdref.detach();
  }

  refresh(){
    const startDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).startOf('month').toFormat(this.dateFormat);
    const endDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).endOf('month').toFormat(this.dateFormat);
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot({department: this.department, endDate: endDateForSlot, startDate: startDateForSlot}));
    if(this.dashboardDetails.viewMode !== 'Month'){
    this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointments({department: this.department, endDate: this.dashboardDetails.endDate,
      startDate: this.dashboardDetails.startDate, filters: this.dashboardDetails.filterValue, viewMode: this.dashboardDetails.viewMode}));
    }

  }

  overrideCapacity(){
    if(this.dashboardDetails.selectedDate && this.dashboardDetails.selectedDate.startOf('day') >= DateTime.now().startOf("day")){
      const dialogRef = this.dialog.open(OverrideDialogComponent ,{
        height:'560px',
        width:'760px',
        panelClass:'overlay-dialog-cdk'
      });

      this.subs.dialogRef = dialogRef.afterClosed().subscribe(result => {

      });
    }else{
      this.alertService.showAlert('otherTexts.cannotChangeCapacityOfAPreviousDatePleaseSelectAnotherDate');
    }
  }

  autoRefresh(){
    this.refreshTime = DateTime.now().toFormat('t');
    // const startDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).startOf('month').toFormat(this.dateFormat);
    // const endDateForSlot = DateTime.fromFormat(this.dashboardDetails.endDate, this.dateFormat).endOf('month').toFormat(this.dateFormat);
    // this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardSlot({department: this.department, endDate: endDateForSlot, startDate: startDateForSlot}));
    if(this.dashboardDetails.viewMode === 'Day'){
    // this.scheduleDashboardState.dispatch(new fromScheduleDashboardActions.LoadScheduleDashboardAppointmentsRefresh({department: this.department, endDate: this.dashboardDetails.endDate,
    //   startDate: this.dashboardDetails.startDate, filters: this.dashboardDetails.filterValue, viewMode: this.dashboardDetails.viewMode}));
    }
  }



  onHoursOfOperationChange(event: string){
    this.hoursOfOperation = event;
  }

  launchdashboardoverlay(){
    const dialogRef = this.dialog.open(DashboardOverlay ,{
        height:'560px',
        width: '40%',
        panelClass:'dashboard-overlay-cdk'
    });

    this.subs.dialogRefOverlay = dialogRef.afterClosed().subscribe(result => {

    });
  }
  openPrintOverlay(){
    const dialogRef = this.dialog.open(DashboardPrintOverlay ,{
          height:'560px',
          panelClass:'dashboard-overlay-cdk',
          data: {department:this.department,appointmentDetails:this.appointmentDetails, clicked: true}
      });

      this.subs.printDialog = dialogRef.afterClosed().subscribe(result => {
      });

  }
  emitAppointmentDetails(event){
    this.appointmentDetails = event;
  }

}
